import axios from "axios";
import store from "@/store/index";

async function uploadCharges(charges) {

    try {
        charges.forEach((charge, i) => {
            setTimeout(async() => {
                store.dispatch("updateUploadingPercentage", {
                    current: i,
                    total: charges.length,
                });
                let jsonData = {
                    url: store.state.login.siteurl,
                    charge,
                };
                await axios.post("api/charges/add", jsonData, {
                    headers: { "Content-Type": "application/json" },
                });

                if (i == charges.length - 1) {
                    return "Done";
                }
            }, i * 1000);
        });

        return "Done";
    } catch (err) {
        // Handle Error Here
        console.error(err);
        return "Error";
    }
}
export default uploadCharges;